import React, { Component } from 'react';

class EPLReference extends Component {
  render() {
    return (
      <div className="docs-content">
        <h2 id="first">Reference is under construction...</h2>
      </div>
    );
  }
}

export default EPLReference;